import {
  Component,
  forwardRef,
  Input,
  OnDestroy,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import {
  ControlValueAccessor,
  FormControl,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AggregateShutdown } from '../../models';

@Component({
  selector: 'backoffice-aggregate-shutdown',
  templateUrl: './aggregate-shutdown.component.html',
  styleUrls: ['./aggregate-shutdown.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AggregateShutdownComponent),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AggregateShutdownComponent
  implements OnInit, OnDestroy, ControlValueAccessor
{
  @Input() label!: string;

  aggregateShutdownList = [...Object.keys(AggregateShutdown)];

  aggregateShutdownControl!: FormControl;

  _aggregateShutdown: AggregateShutdown[] | null = null;
  get aggregateShutdown() {
    return this._aggregateShutdown;
  }
  set aggregateShutdown(val) {
    this._aggregateShutdown = val;

    // map the array to a bool. We still use a bool here as the search query cannot resolve a bit-field
    let valueToPropagate: boolean | null = null;
    if (val != null && val.length === 1) {
      const single = val[0];
      valueToPropagate = single === AggregateShutdown.SHUTDOWN;
    }

    this.propagateChange(valueToPropagate);
  }

  _destroy$ = new Subject<void>();

  ngOnInit() {
    this.aggregateShutdownControl = new FormControl(null);

    this.aggregateShutdownControl.valueChanges
      .pipe(takeUntil(this._destroy$))
      .subscribe((value) => {
        if (Array.isArray(value) && value.length > 0) {
          this.aggregateShutdown = value;
        } else {
          this.aggregateShutdown = null;
        }
      });
  }

  propagateChange = (_: unknown) => {
    /* empty on purpose */
  };

  registerOnChange(fn: (_: unknown) => void) {
    this.propagateChange = fn;
  }

  registerOnTouched() {
    /* empty on purpose */
  }

  writeValue(value: AggregateShutdown[]) {
    this.aggregateShutdown = value;
    if (this.aggregateShutdownControl) {
      this.aggregateShutdownControl.setValue(this.aggregateShutdown);
    }
  }

  ngOnDestroy() {
    this._destroy$.next();
    this._destroy$.complete();
  }
}
